<template>
  <div id="diy-dialog-lines-paper">
    <!-- 试卷难度分布折线图组 -->
    <div id="lines-paper"></div>
    <div id="pie-paper"></div>
  </div>
</template>

<script>
export default {
  name: "div_dialog_lines-paper",
  props: {
    title: {
      // 折线图标题
      type: String,
      default: "",
    },
    xAxis: {
      // X轴
      type: Array,
      default: function () {
        return ["一星", "二星", "三星", "四星", "五星"];
      },
    },
    legend: {
      // 线的种类
      type: Array,
      default: function () {
        return ["单选", "多选", "填空", "判断", "简答"];
      },
    },
    yAxis: {
      // Y轴
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.yAxis,
    };
  },
  watch: {
    yAxis() {
      this.data = this.yAxis;
    },
    data(newValue) {
      this.$emit("showYAxis", this.data);
    },
  },
  methods: {
    initChart() {
      console.log(this.yAxis);
      let examChart = this.$echarts.init(
        document.getElementById("lines-paper")
      );
      let option = {
        title: {
          text: this.title,
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: this.xAxis,
        },
        legend: {
          data: this.legend,
        },
        yAxis: {
          type: "value",
        },
        series: this.yAxis,
      };
      // let option = {
      //   title: {
      //     text: this.title,
      //   },
      //   tooltip: {
      //     trigger: "axis",
      //   },
      //   legend: {
      //     data: this.legend,
      //   },
      //   grid: {
      //     left: "3%",
      //     right: "4%",
      //     bottom: "3%",
      //     containLabel: true,
      //   },
      //   toolbox: {
      //     feature: {
      //       saveAsImage: {},
      //     },
      //   },
      //   xAxis: {
      //     type: "category",
      //     boundaryGap: false,
      //     data: this.xAxis,
      //   },
      //   yAxis: {
      //     type: "value",
      //   },
      //   series: this.yAxis,
      // };
      examChart.setOption(option);
      this.initPie();
    },
    initPie() {
      let examChart = this.$echarts.init(document.getElementById("pie-paper"));
      let data = [];
      this.xAxis.forEach((element) => {
        let dd = { value: 0, name: element };
        data.push(dd);
      });

      this.yAxis.forEach((element) => {
        element.data.forEach((ele, index) => {
          data[index].value += ele;
        });
      });

      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: this.title,
            type: "pie",
            radius: "50%",
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      examChart.setOption(option);
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-lines-paper {
  width: 100%;
  height: 100%;
  #lines-paper {
    width: 100%;
    height: 500px;
  }
  #pie-paper {
    width: 100%;
    height: 500px;
    margin-top: 30px;
  }
}
</style>